import template from './template.html'

angular
  .module('contabilidad.catalogosexternos')
  .component('contabilidadCatalogosexternos', {
    template,
    controller: Controller,
  })
Controller.$inject = []

function Controller () {
  var $ctrl = this
  $ctrl.$onInit = $onInit

  $ctrl.editando = false

  function $onInit () {
    $ctrl.catalogosLNF = [
      {ruta: '.clientes()', label: 'Cuentas Contables Clientes'},
      {ruta: '.proveedores()', label: 'Cuentas Contables Proveedores'},
      {ruta: '.sucursales()', label: 'Cuentas Contables Sucursales'},
    ]
    $ctrl.catalogosAG = [
      {ruta: '.clientesag()', label: 'Cuentas Contables Clientes'},
      {ruta: '.proveedoresag()', label: 'Cuentas Contables Proveedores'},
      {ruta: '.productosag()', label: 'Cuentas Contables Productos'},
      {ruta: '.butacas()', label: 'Cuentas Contables Butacas'},
    ]
  }
}





// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/component.js